function r(o, e, n) {
  const { latitude: i, longitude: l } = o, a = e.map((t) => ({
    lat: t.latitude,
    lng: t.longitude
  })), c = new n.LatLng(i, l), g = new n.Polygon({
    paths: a
  });
  return n.geometry.poly.containsLocation(c, g);
}
export {
  r as isCoordinateWithinBounds
};
